import '~/js/views/general/about/includes/scroll-below';
import 'slick-carousel';
import '~/js/views/general/all-inclusive/includes/nestsuites-slider';


// bathrooms slider options
const $sliderBathrooms = $('.js-slick-slider-bathrooms');

$sliderBathrooms.slick({
    prevArrow: $('.js-bathrooms-prev'),
    nextArrow: $('.js-bathrooms-next'),
    dots: false,
    appendDots: $('.js-bathrooms-append-dots'),
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true
            }
        }
    ]
});

// tranquility slider options
const $sliderTranquility = $('.js-slick-slider-tranquility');

$sliderTranquility.slick({
    prevArrow: $('.js-tranquility-prev'),
    nextArrow: $('.js-tranquility-next'),
    dots: false,
    appendDots: $('.js-tranquility-append-dots'),
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true
            }
        }
    ]
});

// fortwo slider options
const $sliderFortwo = $('.js-slick-slider-fortwo');

$sliderFortwo.slick({
    prevArrow: $('.js-fortwo-prev'),
    nextArrow: $('.js-fortwo-next'),
    dots: false,
    appendDots: $('.js-fortwo-append-dots'),
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                dots: true
            }
        }
    ]
});
